interface Price {
    currency: string;
    value: number;
}

interface RecentlyViewedItem {
    image: string;
    priceFrom: Price;
    priceRegular: Price;
    title: string;
    url: string;
}

interface RecentlyViewedItemState {
    recentItems: RecentlyViewedItem[];
}

const initialRecentlyViewedItemState: RecentlyViewedItemState = {
    recentItems: [],
};

export type { RecentlyViewedItemState, RecentlyViewedItem };
export default initialRecentlyViewedItemState;
